export const DIVIDER_LEFT = "calc(max(0px,(100% - 1280px)/2) + 308px)";
export const H_LINE_LEFT_W = "calc(max(0px,(100% - 1280px)/2) + 258px)";
export const H_LINE_RIGHT_L = "calc(max(0px,(100% - 1280px)/2) + 358px)";
export const SITE_URL = "https://www.kanonics.com";
export const SUPPORTED_LANGS = ["en", "de"] as const;
